import ApiService from 'app/services/ApiService';

export const ADD_CONTRACTS = 'GET_CONTRACTS'
export const ADD_WORKS = 'ADD_WORKS'
export const ADD_PROGRAM = 'ADD_PROGRAM'
export const LOADING_CONTRACT ='LOADING_CONTRACT'
export const LOADING_WORK ='LOADING_WORK'
export const LOADING_PROGRAM ='LOADING_PROGRAM'
export const DOWNLOAD_REPORT = 'DOWNLOAD_REPORT'
export const PERCENT_DOWNLOAD = 'PERCENT_DOWNLOAD'

export const fetchContracts = () => {
    return async ( dispatch ) => {
      try {
        dispatch( setLoadingContract(true) )

        const result =  await ApiService.getContractsForMatriz();
        if( result.data.length === 0 ) return;
        
        let reponse = result.data.map( contract => ({
            contractName: contract.contractName,
            deleted: contract.regDeleted === 0 ? false : true,
            idContract: contract.idContract,
            noContract: contract.noContract
        }))


        dispatch( setContracts( reponse ) )
        dispatch( setLoadingContract(false) )
      } catch (error) {
          dispatch( setContracts( [] ) )
          dispatch( setLoadingContract(false) )
      }
    }
}

export const fetchWorks = (idContract) => {
    return async ( dispatch ) => {
        try {
            dispatch( setLoadingWork(true) )
            const result = await ApiService.getWorksByidContractForMatriz(idContract);

            if( result.data.length === 0 ) return;

            let response = result.data.map( work => ({
                delete: work.regDeleted === 0 ? false : true,
                idContract: work.idContract,
                ot: work.ot,
                workName: work.workName,
                idWork: work.idWork
            }))
 

            dispatch( setWorks( response ) )
            dispatch( setLoadingWork(false) )
        } catch (error) {
            dispatch(setWorks( [] ))
            dispatch( setLoadingWork(false) )
        }
    }
}

export const fetchProgramComunication = (employeeId) => {
    return async (dispatch) => {
        try {
            dispatch( setLoadingProgram(true) )
            const result = await ApiService.getCommunicationProgramsForMatriz(employeeId);
            dispatch( setProgram( result?.listData ) )
            dispatch( setLoadingProgram(false) )
        } catch (error) {
            dispatch( setProgram( [] ) )
            dispatch( setLoadingProgram(false) )
        }
    }
}



// mutations
export const setContracts = (payload) => ({
    type: ADD_CONTRACTS,
    payload: payload
})

export const setWorks = (payload) => ({
    type: ADD_WORKS,
    payload: payload
})

export const setProgram = ( payload ) => ({
    type: ADD_PROGRAM,
    payload: payload
})

export const setLoadingContract = (payload) => ({
    type: LOADING_CONTRACT,
    payload: payload
})

export const setLoadingWork = (payload) => ({
    type: LOADING_WORK,
    payload: payload
})

export const setLoadingProgram = (payload) => ({
    type: LOADING_PROGRAM,
    payload: payload
})

export const setLoadingDownloadRepot = (payload) => ({
    type: DOWNLOAD_REPORT,
    payload: {
        download: payload
    }
})


export const setPercentDownloadReport = (payload) => ({
    type: PERCENT_DOWNLOAD,
    payload: {
        percent: payload
    }
})